import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./reset-password";

export default function AuthPage() {
  return (
    <Switch>
      <Route path="/auth/login" component={Login} />
      <Route path="/auth/registration" component={Registration} />
      <Route path="/auth/forgot-password" component={ForgotPassword} />
      <Route path="/auth/reset-password" component={ResetPassword} />
      <Redirect from="/auth" exact={true} to="/auth/login" />
      <Redirect to="/auth/login" />
    </Switch>
  );
}
